/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">© 2019
      <b><a href="https://artisticvisions.com" target="_blank">Artistic Visions LLC</a></b>
    </span>
    <!--
    <div class="socials">
      <a href="https://vimeo.com/artisticvisionsllc"
        target="_blank" class="ion ion-social-vimeo"></a>
      <a href="https://www.linkedin.com/company/artistic-visions-inc/" 
        target="_blank" class="ion ion-social-linkedin"></a>
      <a href="https://www.facebook.com/artisticvisionsllc/" 
        target="_blank" class="ion ion-social-facebook"></a>
      <a href="https://www.instagram.com/artistic.visions.llc/" 
        target="_blank" class="ion ion-social-instagram"></a>
    </div>-->
  `,
})
export class FooterComponent {
}
